import React, { useEffect } from "react";
import {
  ProfEHero,
  ProfEIntroQuotes,
  ProfEMultiContext,
  ProfEPainpoints,
  ProfEMentorGap,
  ProfERolfeModel,
  ProfEFeatures,
  ProfEDemo,
} from "../components/prof-e";

const ProfessorE: React.FC = () => {
  useEffect(() => {
    document.body.classList.add("page-prof-e");
    return () => {
      document.body.classList.remove("page-prof-e");
    };
  }, []);

  return (
    <main id="main-content" role="main">
      <ProfEHero />
      <ProfEIntroQuotes />
      <ProfEMultiContext />
      <ProfEPainpoints />
      <ProfEMentorGap />
      <ProfERolfeModel />
      <ProfEFeatures />
      <ProfEDemo />
    </main>
  );
};

export default ProfessorE;
